'use client';

import AddressGrid from '@components/address/address-grid';
import { useGetUserProfile } from '@framework/auth/use-get-user-profile';
import { useTranslation } from '@i18n/client';

export default function AddressPageContent({ lang }: { lang: string }) {
  const { t } = useTranslation(lang, 'common');
  const { data: userProfile, isLoading } = useGetUserProfile();
  return (
    <>
      {!isLoading ? (
        <AddressGrid
          showSaveButton={false}
          addresses={userProfile?.addresses ?? []}
          lang={lang}
        />
      ) : (
        <div>{t('text-loading')}</div>
      )}
    </>
  );
}
